import generatePkce from './util/generatePkce';
import generateRandomString from './util/random';
import { storage } from './util/storage';
import { getCurrentUrl } from './util/urls';
import buildAuthorizationUrl from './util/buildAuthorizationUrl';
const interactiveLogin = (clientConfig, redirectUri) => {
    const pkce = generatePkce();
    const state = generateRandomString(32);
    const request = {
        clientId: clientConfig.clientId,
        scopes: clientConfig.scopes,
        redirectUri: redirectUri || getCurrentUrl(),
        codeChallenge: pkce.codeChallenge,
        state: state,
        responseType: 'code token',
    };
    const url = buildAuthorizationUrl(request);
    storage.write({
        state: state,
        codeVerifier: pkce.codeVerifier,
    });
    window.location.href = url;
};
export { interactiveLogin };
//# sourceMappingURL=login.js.map